<!--
 * @Description: 
 * @Author: 
 * @Date: 2023-09-21 12:30:45
 * @LastEditTime: 2024-03-20 08:42:14
 * @LastEditors: Please set LastEditors
-->
<template>
  <div class="center-box-div">
    <div class="title-box01">
      <div class="title-box02">
        <div class="title-name">数据总览</div>
        <div class="top-statistics">
          <table class="table_data02">
            <tr>
              <td class="font07 fs18">企业数量</td>
              <td class="font03 fs18">4819个</td>
              <td class="font07 fs18">规上工业总产值</td>
              <td class="font02 fs18">1552万元</td>
            </tr>
            <tr>
              <td class="font07 fs18">招商引资到位资金</td>
              <td class="font01 fs18">1211万元</td>
              <td class="font07 fs18">企业研发投入</td>
              <td class="font01 fs18">149万元</td>
            </tr>
          </table>

          <!-- 饼状图myRightPie -->
          <div class="flex justify-between mar-t-10">
            <!-- <div id="mychar" style="width: 48%; height: 248px"></div> -->

            <!-- <div id="myRightPie" style="width: 47%; height: 248px"></div> -->
          </div>

          <!-- 双向数据对比柱状图 -->
          <div class="mar-t-20">
            <div
              id="bidirectionalData"
              style="width: 100%;  height: calc(100vh - 430px)"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "mianIndex",
  props: {},
  data() {
    return {};
  },

  mounted() {
    // this.getCharts();
    // this.getChartsTightPie();
    this.getBidirectionalDataCharts();
  },
  methods: {
    // 获取第一个饼状图
    getCharts() {
      const chartBox = this.$echarts.init(document.getElementById("mychar"));
      const option = {
        title: {
          text: "销售量组成",
          textStyle: {
            color: "#e9ebee",
            fontSize: 16
          },

          x: "center"
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          x: "left",
          data: ["销售A", "销售B", "销售C", "销售D", "销售E"],
          icon: "triangle",
          itemHeight: 12.5,
          itemWidth: 13.5,
          textStyle: {
            color: "#e9ebee",
            fontSize: "10"
          }
        },

        calculable: false,
        series: [
          {
            name: "销售组成",
            type: "pie",
            radius: "55%",
            center: ["50%", "60%"],
            data: [
              {
                value: 335,
                name: "销售A",
                itemStyle: {
                  normal: {
                    color: "#1afffd"
                  }
                }
              },
              {
                value: 310,
                name: "销售B",
                itemStyle: {
                  normal: {
                    color: "#2e7cff"
                  }
                }
              },
              {
                value: 234,
                name: "销售C",
                itemStyle: {
                  normal: {
                    color: "#ffcb89"
                  }
                }
              },
              {
                value: 135,
                name: "销售D",
                itemStyle: {
                  normal: {
                    color: "#005ea1"
                  }
                }
              },
              {
                value: 1548,
                name: "销售E",
                itemStyle: {
                  normal: {
                    color: "#0ad5ff"
                  }
                }
              }
            ]
          }
        ]
      };
      chartBox.setOption(option);
      // 根据页面大小自动响应图表大小
      window.addEventListener("resize", function() {
        chartBox.resize();
      });
    },

    // 右侧饼状图
    getChartsTightPie() {
      const chartBox = this.$echarts.init(
        document.getElementById("myRightPie")
      );
      const option = {
        title: {
          text: "营销投入组成",
          textStyle: {
            color: "#e9ebee",
            fontSize: 16
          },

          x: "center"
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          type: "scroll",
          orient: "vertical",
          x: "left",
          itemHeight: 8.5,
          itemWidth: 9.5,
          data: [
            "企业1",
            "企业2",
            "企业3",
            "企业4",
            "企业5",
            "企业6",
            "企业7",
            "企业8",
            "企业9"
          ],
          textStyle: {
            color: "#e9ebee",
            fontSize: "10"
          }
        },

        calculable: false,
        series: [
          {
            name: "销售组成",
            type: "pie",
            radius: "55%",
            center: ["50%", "60%"],
            data: [
              {
                value: 335,
                name: "企业1",
                itemStyle: {
                  normal: {
                    color: "#06b8f8"
                  }
                }
              },
              {
                value: 310,
                name: "企业2",
                itemStyle: {
                  normal: {
                    color: "#ff5c58"
                  }
                }
              },
              {
                value: 234,
                name: "企业3",
                itemStyle: {
                  normal: {
                    color: "#ffffb3"
                  }
                }
              },
              {
                value: 135,
                name: "企业4",
                itemStyle: {
                  normal: {
                    color: "#fee581"
                  }
                }
              },
              {
                value: 1548,
                name: "企业5",
                itemStyle: {
                  normal: {
                    color: "#1afffd"
                  }
                }
              },
              {
                value: 135,
                name: "企业6",
                itemStyle: {
                  normal: {
                    color: "#1ec7f1"
                  }
                }
              },
              {
                value: 135,
                name: "企业7",
                itemStyle: {
                  normal: {
                    color: "#e15828"
                  }
                }
              },
              {
                value: 135,
                name: "企业8",
                itemStyle: {
                  normal: {
                    color: "#28a3e1"
                  }
                }
              },
              {
                value: 135,
                name: "企业9",
                itemStyle: {
                  normal: {
                    color: "#72e7d5"
                  }
                }
              }
            ]
          }
        ]
      };
      chartBox.setOption(option);
      // 根据页面大小自动响应图表大小
      window.addEventListener("resize", function() {
        chartBox.resize();
      });
    },

    // 获取双向数据对比图
    getBidirectionalDataCharts() {
      const chartBox = this.$echarts.init(
        document.getElementById("bidirectionalData")
      );
      const option = {
        color: ["#2481FF", "#1AFFFD"],
        title: {
          text: "2024年1-2月主要经济指标完成情况",
          x: "center",
          textStyle: {
            color: "#e9ebee",
            fontSize: "24"
          },
          subtext: "单位：万元",
          subtextStyle: {
            color: "#e9ebee",
            fontSize: "16"
          }
        },

        tooltip: {
          trigger: "axis"
        },
        legend: {
          orient: "vertical",
          itemHeight: 8.5,
          itemWidth: 9.5,
          icon: "rect",
          data: ["2022年", "2023年"],
          x: "left",
          textStyle: {
            color: "#e9ebee",
            fontSize: "10"
          }
        },
        // toolbox: {
        //   show: true,
        //   feature: {
        //     dataView: { show: true, readOnly: false },
        //     magicType: { show: true, type: ["line", "bar"] },
        //     restore: { show: true },
        //     saveAsImage: { show: true }
        //   }
        // },
        calculable: false,
        xAxis: [
          {
            type: "category",
            // prettier-ignore
            data: ['限上批发和零售业', '规上工业总产值',"招商引资到位资金",'限上住宿和餐饮业', "固定资产投资","研发投入"],
            axisTick: { alignWithLabel: true }, // 刻度居中核心代码
            axisLabel: {
              formatter: function(value) {
                var result = "";
                var maxLength = 4; // 每行最多显示3个字符
                for (var i = 0, len = value.length; i < len; i += maxLength) {
                  result += value.slice(i, i + maxLength) + "\n";
                }
                return result;
              },
              // formatter: "{value} ",
              // interval: 0, //横轴信息全部显示
              // rotate: 45, //倾斜度 -90 至 90 默认为0
              // margin: 5, //刻度标签与轴线之间的距离

              textStyle: {
                color: "#fff",
                align: "center",
                fontSize: 10
              }
            },
            //是否显示横线
            splitLine: {
              show: false
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            //是否显示横线
            splitLine: {
              show: false
            },
            axisLabel: {
              //x轴文字的配置
              show: true,
              textStyle: {
                color: "#fff"
              }
            }
          }
        ],
        series: [
          {
            name: "2024年",
            type: "bar",
            // data: [1725180, 786229.84, 400194, 177924, 75274, 412.6],
            data: [37608.2, 15526, 1211, 8845.1, 14322, 149],
            formatter: function(value, index) {
              return value.toFixed(2);
            },
            // markPoint: {
            //   data: [
            //     { name: "Max", value: 182.2, xAxis: 7, yAxis: 183 },
            //     { name: "Min", value: 2.3, xAxis: 11, yAxis: 3 }
            //   ]
            // },
            markLine: {
              data: [{ type: "average", name: "Avg" }]
            }
          },
          {
            name: "2023年",
            type: "bar",
            // data: [1401953, 610730.17, 316574, 112695, 23200, 310.3],
            data: [31195.9, 13280, 1171, 6909.8, 9904, 92],
            markPoint: {
              data: [
                { type: "max", name: "Max" },
                { type: "min", name: "Min" }
              ]
            },
            markLine: {
              data: [{ type: "average", name: "Avg" }]
            }
          }
        ]
      };
      chartBox.setOption(option);
      // 根据页面大小自动响应图表大小
      window.addEventListener("resize", function() {
        chartBox.resize();
      });
    }
  }
};
</script>

<style scoped>
.center-box-div {
  width: 46%;
}

.title-name {
  width: 44%;
  height: 4%;
  margin: 0 auto;
  font-size: 1em;
  color: #ffffff;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.table_data02 {
  width: 96%;
  margin-left: 2%;
  border-collapse: collapse;
  color: #ffffff;
  margin-top: 10px;
  border-radius: 5px;
  border: 1px solid #5bc0de;
  font-weight: bold;
}

.table_data02 tr td {
  padding-top: 2.5%;
  padding-bottom: 2.5%;
  text-indent: 6px;
}

.font03 {
  color: #e9a832;
  font-weight: bold;
}

.font02 {
  color: #e9230d;
  font-weight: bold;
}

.font01 {
  color: #4cae4c;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/center-box.vue